export const GAME_MODE = {
  PLAY: 'play',
  DEMO: 'demo',
}

export const REQUEST_BY_RESOLUTION = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
}

export const SEO_PAGE_TYPE = {
  GAME: 'game',
  PROVIDER: 'provider',
}
